<template>
  <div v-show="isOutputList" id="output_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div class="table_wrapper">
      <!--  タイトルエリア  -->
      <div class="title_area">
        <h3 v-if="isOutputList">出力物リスト</h3>
      </div>
      <div class="form_area">
        <div class="button_area">
          <span>種類選択：</span>
          <select v-model.number="selectedType" @change="getOutputList">
            <option value=0>全部</option>
            <option v-for="(type,index) in dispOutputTypeList" :key="index" :value="type.code">{{type.label}}</option>
          </select>
        </div>
        <!-- ページ -->
        <div>
          <dd-pager
            ref="pagerRef"
            :pageNo="pageNo"
            :dataCountPerPage="dataCount"
            :totalDataCount="totalCount"
            @paging="paging"
          />
        </div>
      </div>
      <!-- データテーブル -->
      <div class="plan_list_area">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>出力日</th>
              <th>種類</th>
              <th>ファイルコード</th>
              <th>プラン名</th>
              <th>保存回数</th>
              <th>出力回数</th>
              <th>ファイル名</th>
              <th>生産単位コード</th>
              <th>出力担当者名</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(output, index) in outputDataList" :key="index">
              <td class="download_icon">
                <a @click.prevent="fileDownload(output)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              </td>
              <td>{{ getFormatDate(output.outputDate) }}</td>
              <td>{{ getOutputType(output.outputType) }}</td>
              <td>{{ output.outputFileCode }}</td>
              <td>{{ output.outputFdId }}</td>
              <td>{{ output.outputFdSaveCount }}</td>
              <td>{{ output.outputFdOutputCount }}</td>
              <td>{{ output.outputOutFilename }}</td>
              <td>{{ output.outputRotCode}}</td>
              <td>{{ output.userName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {API_URL} from '../../constants/App'
import {OUTPUT_TYPE} from '../../constants/Type'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as LicenseUtil from '../../utils/License'
import LoadingModal from '../common/LoadingModal'
import Pager from '../../components/common/OrderPager'

export default {
  name: 'OutputTable',
  components: {
    'dd-loading-modal': LoadingModal,
    'dd-pager': Pager
  },
  props: {
    isOutputList: Boolean
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** 出力物リスト全件 */
      outputDataList: [],
      /** 出力種別リスト */
      outputTypeList: OUTPUT_TYPE,
      /** 検索条件 */
      searchForm: {
        outputType: [],
        pageNo: '',
        dataCount: ''
      },
      /** 選択中出力種別 */
      selectedType: 0
    }
  },
  computed: {
    dispOutputTypeList: function () {
      // CGは未対応のため選択リストから除外
      let dispList = Object.entries(this.outputTypeList).map(([key, value]) => (value))
        .filter(type => type.code !== OUTPUT_TYPE.OUTPUT_CG.code)
        .filter(type => LicenseUtil.checkLicense(type.code))
      return dispList
    }
  },
  methods: {
    /** 出力物リストの取得・表示 */
    getOutputList: function () {
      this.pageNo = 1
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch()
    },
    /** 出力物リストを条件で検索 */
    onSearch: function () {
      // 取得する出力種別を設定
      let outputTypeList = []
      if (this.selectedType !== 0) {
        outputTypeList.push(this.selectedType)
      } else {
        outputTypeList = this.dispOutputTypeList.map(type => type.code)
      }
      this.searchForm.outputType = outputTypeList
      let payload = this.searchForm
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.OUTPUT + '/list', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.outputDataList = response.data.data.columnDataList
          this.totalCount = response.data.data.totalCount
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 選択した出力物のダウンロード */
    fileDownload: function (outputData) {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'POST',
        url: API_URL.OUTPUT + '/download',
        responseType: 'blob',
        data: {
          outputOutPath: outputData.outputOutPath,
          outputFdId: outputData.outputFdId,
          outputFdSaveCount: outputData.outputFdSaveCount,
          outputFdOutputCount: outputData.outputFdOutputCount,
          outputOutFilename: outputData.outputOutFilename,
          outputRotCode: outputData.outputRotCode
        }
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          var data = response.data
          let blob = new Blob([data], {type: 'application/octet-stream;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, outputData.outputOutFilename)
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = outputData.outputOutFilename
            link.click()
          }
        }
      }).catch(error => {
        Api.handleError(error)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch()
    },
    /** 出力物種別名を取得 */
    getOutputType: function (code) {
      return this.dispOutputTypeList.find(type => type.code === code).label
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    getFormatSimpleDate: function (date) {
      if (date) {
        return moment(date).format('M/DD')
      } else {
        return ''
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#output_table {
  height: 95%;
  width: 95%;
  padding: 10px 30px;
}
.title_area {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/output/OutputTable.vue